import { useState } from "react";
import { useNavigate } from "react-router";
import LegalAidTable from "../../../components/LegalAidTable";
import RoundedCard from "../../../components/RoundedCard";
import { useLegalAids } from "@/hooks/useLegalAid";
import LegalAidUploadDialog from "./LegalAidUploadDialog";

type LegalAidDocumentTabProps = {
  detailPathPrefix?: string;
  description: string | null;
  reported?: boolean | null;
  showStatusColumn?: boolean;
  title: string;
};

const LEGAL_AID_PAGE_SIZE = 10;

const LegalAidDocumentTab = ({
  detailPathPrefix = "",
  description,
  reported,
  showStatusColumn = true,
  title,
}: LegalAidDocumentTabProps) => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const {
    data: response,
    isError,
    isFetching,
    isLoading,
  } = useLegalAids({
    page,
    page_size: LEGAL_AID_PAGE_SIZE,
    reported,
  });

  const handleLegalAidClick = (documentId: string) => {
    void navigate(`${detailPathPrefix}advokatvagt-retshjaelp/${documentId}`);
  };

  return (
    <RoundedCard
      bodyClassName="p-0 mt-3"
      header={title}
      description={description}
      action={<LegalAidUploadDialog />}
    >
      <LegalAidTable
        isError={isError}
        isLoading={isLoading}
        onLegalAidClick={handleLegalAidClick}
        legalAids={response?.items ?? []}
        showStatusColumn={showStatusColumn}
        pagination={
          response
            ? {
                isDisabled: isFetching,
                onPageChange: setPage,
                page: response.page,
                total: response.total,
                totalPages: response.totalPages,
              }
            : undefined
        }
      />
    </RoundedCard>
  );
};

export default LegalAidDocumentTab;
